// ------------------------------------
// Loader
// ------------------------------------

// Variáveis
const $loader = $('#loader');
const $loaderTitle = $('#loader-title');
const $loaderText = $('#loader-text');

// Exibe o loader
function showLoader(title = '', text = '') {
  $loaderTitle.html(title);
  $loaderText.html(text);
  $loader.addClass('active');
  $('body').addClass('modal-open');
}

// Oculta o loader
function hideLoader() {
  $loader.removeClass('active');
  $('body').removeClass('modal-open');
}
